import styled from '@emotion/styled';
import { settingsTheme as t } from '../../theme';

type Variant = 'primary' | 'secondary' | 'danger';
type Size = 'md' | 'sm';

interface ButtonProps {
  variant?: Variant;
  size?: Size;
}

const SIZES = {
  md: { padding: '12px 20px', fontSize: 14, fontWeight: 600, radius: '10px', iconSize: 20 },
  sm: { padding: '9px 15px', fontSize: 13.5, fontWeight: 500, radius: '9px', iconSize: 18 },
} as const;

const VARIANTS = {
  primary: {
    background: t.color.primary,
    color: t.color.surface,
    border: t.color.primary,
    hoverBackground: t.color.primaryHover,
  },
  secondary: {
    background: t.color.surface,
    color: t.color.text,
    border: t.color.inputBorder,
    hoverBackground: '#f4f6f9',
  },
  danger: {
    background: t.color.danger,
    color: t.color.surface,
    border: t.color.danger,
    hoverBackground: t.color.dangerHover,
  },
} as const;

/**
 * Primitivo de botón con tres variantes: primaria (verde de marca), secundaria
 * (contorno neutro) y destructiva (rojo). Admite un icono como hijo.
 */
const Button = styled.button<ButtonProps>(({ variant = 'primary', size = 'md' }) => {
  const v = VARIANTS[variant];
  const s = SIZES[size];
  return {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    fontFamily: t.font,
    fontSize: s.fontSize,
    fontWeight: s.fontWeight,
    lineHeight: 1,
    padding: s.padding,
    borderRadius: s.radius,
    border: `1px solid ${v.border}`,
    background: v.background,
    color: v.color,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'background 0.15s ease, border-color 0.15s ease',
    '& .MuiSvgIcon-root': { fontSize: s.iconSize },
    '&:hover': { background: v.hoverBackground },
    '&:disabled': { opacity: 0.6, cursor: 'not-allowed' },
  };
});

export default Button;
